import type { DictationSession } from './dictation-support'
import { usesNativeDictation } from './dictation-support'
import { useNativeDictation } from './use-native-dictation'
import { useScribeDictation } from './use-scribe-dictation'

/**
 * Speech-to-text for any composer, on whichever engine fits the device:
 * streaming ElevenLabs Scribe on desktop, the browser's native
 * `SpeechRecognition` on phones/tablets (see `dictation-support.ts`). Same
 * contract either way: `start` begins listening, `stop` ends it, and the final
 * transcript is emitted to `onTranscript` exactly once. Both engine hooks are
 * always called (rules of hooks); only the one for this device is ever started.
 */
export function useVoiceDictation(options: {
  /** Called once, with the final transcript, after the user stops recording. */
  onTranscript: (sessionText: string) => void
}): DictationSession {
  const scribe = useScribeDictation(options)
  const native = useNativeDictation(options)
  return usesNativeDictation() ? native : scribe
}
